import Input, { Sizes as InputSizes, Types as InputTypes } from '../Input'

interface TextBoxProps {
    onChange?: (e: React.FormEvent) => void
    value?: string
}

export default function TextBox(props: TextBoxProps) {
    const { onChange = () => undefined, value = '' } = props

    return <Input size={InputSizes.LG} type={InputTypes.TEXTAREA} noresize onChange={onChange} value={value} />
}
